import { Injectable, inject } from '@angular/core';

import { DynamicLayoutService, EmbeddableComponentsService, OnFeatureInit } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { LoginDurationConfig } from './login-duration.client-config';
import { LoginDurationComponent } from './login-duration.component';

@Injectable()
export class LoginDurationBootstrapService implements OnFeatureInit {
    private readonly config = inject(LoginDurationConfig);
    private readonly dynamicLayoutService = inject(DynamicLayoutService);
    private readonly embeddableComponentsService = inject(EmbeddableComponentsService);

    async onFeatureInit() {
        await firstValueFrom(this.config.whenReady);

        this.embeddableComponentsService.registerEmbeddableComponent(LoginDurationComponent, 100);

        if (this.config.slotName) {
            this.dynamicLayoutService.addComponent(this.config.slotName, LoginDurationComponent, null);
        }
    }
}
